import ReactDOM from 'react-dom';
import { StrictMode } from 'react';
import './index.css';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { plPL as corePlPL } from '@mui/material/locale';

let theme = createTheme({
  typography: {
    fontFamily: `"Rajdhani", sans-serif`,
    fontSize: 17,
    fontWeightSemiBold: 600,
  },
  corePlPL,
});

ReactDOM.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </StrictMode>,
  document.getElementById('root')
);
